import React, { useEffect } from "react";
import "./../lib/css/bootstrap.min.css";
import "./../css/index.css";
import "./../css/App-v2.css";
import { ShowcaseSectionItem } from "../components/ShowcaseSectionItem";

import HeaderSection from "../components/HeaderSection";
import { menuData, profileData } from "../const/profileConstants";
import IntoductoryItem from "../components/IntoductoryItem";
import { HistoryGroupItem } from "../components/HistoryGroupItem";
import { SkillItem } from "../components/SkillItem";
import CourseItem from "../components/CourseItem";
import ContactItem from "../components/ContactItem";
import { scrollToDiv } from "../utility";

export function Root() {
  useEffect(() => {
    scrollToDiv(menuData[2].key);
  }, []);

  return (
    <div id="root">
      <HeaderSection />

      <div id={menuData[0].key}>
        <IntoductoryItem />
      </div>

      <div id={menuData[1].key}>
        <HistoryGroupItem
          heading={menuData[1].value}
          data={profileData.experience}
        />
      </div>

      <div id={menuData[2].key}>
        <ShowcaseSectionItem />
      </div>

      <div id={menuData[3].key}>
        <HistoryGroupItem
          heading={menuData[3].value}
          data={profileData.education}
        />
      </div>

      <div id={menuData[4].key}>
        <SkillItem />
      </div>

      <div id={menuData[5].key}>
        <CourseItem />
      </div>

      <div id={menuData[6].key}>
        <ContactItem />
      </div>
    </div>
  );
}

export default Root;
